<svg:rect class="production-schedule-path-background" width="100%" [attr.height]="productionScheduleBuilderHeight"></svg:rect>

<ng-container *ngIf="hasPermissionToNewVerifyStep()">
  <svg:svg
    #itemsInPathGroup
    app-production-schedule-item-in-path-group-container-new
    class="production-schedule-item-in-path-group-container"
    *ngFor="let productionScheduleItemInPathGroup of productionSchedulePath.pathGroups; let productionScheduleItemInPathGroupIndex = index"
    [productionScheduleItemIndexInPath]="productionScheduleItemInPathGroupIndex"
    [commercialUnit]="commercialUnit"
    [productionSchedule]="productionSchedule"
    [productionScheduleBuilderHeight]="productionScheduleBuilderHeight"
    [productionScheduleItem]="productionScheduleItemInPathGroup"
    [aspectRatio]="aspectRatio"
    [productionSchedulePathIndex]="productionSchedulePathIndex"
    [productionScheduleColoredYarnSet]="productionSchedulePathsOfColoredYarnSet.productionScheduleColoredYarnSet"
    [productionSchedulePhase]="productionSchedulePhase"
    [productionOrderCustomSettings]="productionOrderCustomSettings"
    [isProductionScheduleDisplayOverview]="isProductionScheduleDisplayOverview"
    (mouseenter)="openHoverInfoTooltip($event, productionScheduleItemInPathGroup, productionScheduleItemInPathGroupIndex)"
    (mouseup)="openHoverInfoTooltip($event, productionScheduleItemInPathGroup, productionScheduleItemInPathGroupIndex)"
    (mouseleave)="closeHoverInfoTooltip()"
  ></svg:svg>
</ng-container>

<ng-container *ngIf="!hasPermissionToNewVerifyStep()">
  <svg:svg
    #itemsInPathGroup
    app-production-schedule-item-in-path-group-container
    *ngFor="let productionScheduleItemInPathGroup of productionSchedulePath.pathGroups; let productionScheduleItemInPathGroupIndex = index"
    [productionScheduleItemIndexInPath]="productionScheduleItemInPathGroupIndex"
    [commercialUnit]="commercialUnit"
    [productionSchedule]="productionSchedule"
    [productionScheduleBuilderHeight]="productionScheduleBuilderHeight"
    [productionScheduleItem]="productionScheduleItemInPathGroup"
    [aspectRatio]="aspectRatio"
    [productionSchedulePathIndex]="productionSchedulePathIndex"
    [productionScheduleColoredYarnSet]="productionSchedulePathsOfColoredYarnSet.productionScheduleColoredYarnSet"
    [productionSchedulePhase]="productionSchedulePhase"
    [productionOrderCustomSettings]="productionOrderCustomSettings"
    [isProductionScheduleDisplayOverview]="isProductionScheduleDisplayOverview"
    appDataCy="production-schedule-item"
  ></svg:svg>
</ng-container>

<svg:rect
  class="production-schedule-path-separator"
  [attr.height]="productionScheduleBuilderHeight"
  [attr.width]="productionSchedulePathSeparatorWidth"
  [attr.x]="getProductionSchedulePathSeparatorHorizontalPosition()"
></svg:rect>

<svg:rect
  *ngIf="isEditPathsEnabled"
  class="production-schedule-path-edit-overlay"
  appDataCy="production-schedule-path-edit-overlay"
  height="100%"
  (click)="onClickProductionSchedulePathEditOverlay($event)"
></svg:rect>
